import React from 'react';

const groups = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.8334 24.5V22.1667C19.8334 20.929 19.3417 19.742 18.4666 18.8668C17.5914 17.9917 16.4044 17.5 15.1667 17.5H5.83341C4.59574 17.5 3.40875 17.9917 2.53358 18.8668C1.65841 19.742 1.16675 20.929 1.16675 22.1667V24.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4999 12.8333C13.0772 12.8333 15.1666 10.744 15.1666 8.16667C15.1666 5.58934 13.0772 3.5 10.4999 3.5C7.92259 3.5 5.83325 5.58934 5.83325 8.16667C5.83325 10.744 7.92259 12.8333 10.4999 12.8333Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8333 24.5V22.1666C26.8325 21.1327 26.4883 20.1282 25.8548 19.311C25.2214 18.4938 24.3344 17.9101 23.3333 17.6516"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6667 3.65164C19.6706 3.90866 20.5603 4.49246 21.1957 5.311C21.831 6.12955 22.1759 7.13628 22.1759 8.17248C22.1759 9.20867 21.831 10.2154 21.1957 11.0339C20.5603 11.8525 19.6706 12.4363 18.6667 12.6933"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default groups;
